import * as apiFactory from "./ApiFactory";

import type { Tag, FileTag } from "@/models/Tag";
import type { TagType } from "@/models/TagType";

export async function getTagTypes(clientName: string, brand: string): Promise<TagType[]> {
  const client = await apiFactory.FeatuerWithBearer();
  return client.get<TagType[]>(["api/tagtype", clientName, brand]);
}

export async function getAllTags(clientName: string, brand: string, caseReference: string): Promise<Tag[]> {
  const client = await apiFactory.FeatuerWithBearer();
  return client.get<Tag[]>(["api/tag", clientName, brand, caseReference]);
}

export async function getAllFileTags(clientName: string, brand: string, caseReference: string): Promise<FileTag[]> {
  const client = await apiFactory.FeatuerWithBearer();
  return client.getWithPollingSignal<FileTag[]>(["api/filetag", clientName, brand, caseReference]);
}

export async function saveTag(clientName: string, tag: Tag): Promise<void> {
  const client = await apiFactory.WithBearer();
  return client.post<Tag, void>(["api/tag", clientName, tag.brand, tag.caseReference], tag);
}

export async function deleteTag(clientName: string, tag: Tag): Promise<void> {
  const client = await apiFactory.WithBearer();
  return client.delete(["api/tag", clientName, tag.brand, tag.caseReference, tag.name]);
}

export async function saveFileTag(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  name: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  return client.post<null, void>(["api/filetag", clientName, brand, caseReference, fileReference, name]);
}

export async function deleteFileTag(
  clientName: string,
  brand: string,
  caseReference: string,
  fileReference: string,
  name: string,
): Promise<void> {
  const client = await apiFactory.WithBearer();
  return client.delete(["api/filetag", clientName, brand, caseReference, fileReference, name]);
}
